import React, { useEffect, useState } from "react";
import { Col, Button, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { AddEditModal } from "../index";
import AddPaymentForm from "@me-team/common/src/components/Salary/AddPaymentForm";

interface PeriodSummaryRowProps {
    isButton?: boolean;
    canCreatePayment?: boolean;
    totalCost: number;
    currency: string;
    totalItems: number;
    isAddPaymentModalOpened?: boolean;
    toggleAddPaymentModal?: () => void;
    refetchSalaryPayment?: () => void;
    refetchSalary?: () => void;
}

const PeriodSummaryRow: React.FC<PeriodSummaryRowProps> = ({
    isButton,
    canCreatePayment,
    totalCost,
    totalItems,
    currency,
    isAddPaymentModalOpened,
    toggleAddPaymentModal,
    refetchSalaryPayment,
    refetchSalary,
}) => {
    const { t } = useTranslation();
    const [isModalOpened, setIsModalOpened] = useState(false);
    const shouldShowAddPaymentButton = canCreatePayment ?? isButton;
    const shouldRenderAddPaymentModal = canCreatePayment === undefined ? true : canCreatePayment;

    useEffect(() => {
        if (isAddPaymentModalOpened) {
            setIsModalOpened(isAddPaymentModalOpened);
        }
    }, [isAddPaymentModalOpened]);

    const handleShowAddPaymentModal = () => {
        setIsModalOpened(true);
    };
    const handleModalClose = () => {
        setIsModalOpened(false);
        toggleAddPaymentModal && toggleAddPaymentModal();
    };

    return (
        <Row className="px-4 py-3 bg-violet-light mx-0">
            <Col lg={12} className="d-sm-flex align-items-center gap-4 px-0">
                <p className="m-0">
                    {t("Total for the period -")}
                    <span className="fw-bold ms-1">{totalCost}</span> {t(currency)} {t("for")}{" "}
                    <span className="fw-bold">{totalItems}</span> {t("performed services")}
                </p>
                {shouldShowAddPaymentButton && (
                    <Col sm={5} lg={4} xl={2}>
                        <Button
                            variant="primary"
                            size="sm"
                            className="w-100  mt-3 mt-sm-0"
                            onClick={handleShowAddPaymentModal}
                        >
                            <i className="bi bi-plus-lg fw-bold me-2 w-100 h-100"></i>
                            {t("Add Payment")}
                        </Button>
                    </Col>
                )}
            </Col>
            {shouldRenderAddPaymentModal ? (
                <AddEditModal
                    title={t("Add Payment")}
                    isModalOpened={isModalOpened}
                    setIsModalOpened={handleModalClose}
                >
                    <AddPaymentForm
                        handleModalClose={handleModalClose}
                        refetchSalaryPayment={refetchSalaryPayment}
                        refetchSalary={refetchSalary}
                    />
                </AddEditModal>
            ) : null}
        </Row>
    );
};

export default PeriodSummaryRow;
